import formMixin from '../../../mixins/formMixin'

export default {
    name: 'FormRadio',

    mixins: [formMixin]
}
